module.exports = __webpack_public_path__ + "img/i-games-admin.9065d9fe.svg";